var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMapBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.23182 0 0 4.23182 0 9.5C0 14.7682 4.23182 19 9.5 19C14.7682 19 19 14.7682 19 9.5C19 4.23182 14.7682 0 9.5 0ZM10.3636 11.1409L4.49091 12.6955C4.49091 12.6955 4.40455 12.6955 4.31818 12.6091C4.23182 12.5227 4.23182 12.4364 4.31818 12.35L8.55 8.03182C8.55 7.94545 8.63636 7.94545 8.63636 7.94545L14.5091 6.39091C14.5091 6.39091 14.5955 6.39091 14.6818 6.47727C14.7682 6.56364 14.6818 6.65 14.6818 6.82273L10.3636 11.1409Z",
    fill: "#0296DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75746 10.5364L5.87109 11.5727L8.72109 8.72275L9.75746 10.5364Z",
    fill: "#0296DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapBlue);
export default __webpack_public_path__ + "static/media/ico_map_blue.74ff2f38.svg";
export { ForwardRef as ReactComponent };